import { render, staticRenderFns } from "./SkillSchemes.vue?vue&type=template&id=2bae6928&"
import script from "./SkillSchemes.vue?vue&type=script&lang=js&"
export * from "./SkillSchemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports